import { CreditCardBitsModule } from './creditCardBits/creditCardBits.module';

import { AddCreditCardComponent } from './add_credit_card.component';
import { CashComponent } from './cash.component';
import { CreditCardCardComponent } from './credit_card_card.component';
import { CreditCardPickerComponent } from './credit_card_picker.component';
import { PaymentAuthenticatedComponent } from './payment_authenticated.component';
import { PaymentGuestComponent } from './payment_guest.component';
import { TipComponent } from './tip.component';

import { FormattedTipDirective } from './formatted_tip.directive';

import { PaymentService } from './payment.service';

import './payment.scss';

export const PaymentModule = angular
    .module('oo.checkout.checkoutSteps.payment', [CreditCardBitsModule])
    .component('addCreditCard', AddCreditCardComponent)
    .component('cash', CashComponent)
    .component('creditCardCard', CreditCardCardComponent)
    .component('creditCardPicker', CreditCardPickerComponent)
    .component('paymentAuthenticated', PaymentAuthenticatedComponent)
    .component('paymentGuest', PaymentGuestComponent)
    .component('ooTip', TipComponent)
    .directive('formattedTip', FormattedTipDirective)
    .service('paymentService', PaymentService)

    .name;
